// Languages the UI can show, and the lookup behind t(). Static UI text lives in the dictionaries
// under ./strings, never generated by the LLM. Adding a language: add it here, then add its block
// to each dictionary (missing keys fall back to English).
export const LANGUAGES = {
  english: { short: "EN", name: "English", locale: "en-US", html: "en" },
  tagalog: { short: "FIL", name: "Tagalog", locale: "fil-PH", html: "fil" },
};

export const DEFAULT_LANG = "english";

export const isLanguage = (lang) => typeof lang === "string" && Object.prototype.hasOwnProperty.call(LANGUAGES, lang);

const lookup = (table, key) =>
  key.split(".").reduce((node, part) => (node && typeof node === "object" ? node[part] : undefined), table);

const fill = (text, vars) =>
  vars ? text.replace(/\{(\w+)\}/g, (match, name) => (vars[name] !== undefined ? String(vars[name]) : match)) : text;

/**
 * A translator over one dictionary ({english: {...}, tagalog: {...}}) for one language.
 * t("hero.videoIs") or t("frames.flagged", {n: 2}): the language's text, then English, then the key.
 * t.value("status", "AI-Generated"): a word from a fixed set (statuses, metadata values) whose
 * English form is also its key; anything not in the set comes back unchanged.
 */
export function makeT(dict, lang) {
  const own = dict[lang] || {};
  const base = dict[DEFAULT_LANG] || {};
  const t = (key, vars) => {
    let text = lookup(own, key);
    if (typeof text !== "string") text = lookup(base, key);
    return typeof text === "string" ? fill(text, vars) : key;
  };
  t.value = (group, raw) => {
    if (raw === undefined || raw === null || raw === "") return raw;
    const text = own[group]?.[raw] ?? base[group]?.[raw];
    return typeof text === "string" ? text : raw;
  };
  t.lang = lang;
  return t;
}
